import { Packr } from 'msgpackr';
import { MessageType } from '../types/protocol.js';
import { InputMessage, ConnectMessage, SnapshotMessage } from '../types/protocol.js';
import { createHeader, HEADER_SIZE } from './types.js';
import { compressSnapshot } from './compress.js';

const packr = new Packr({
  useRecords: false,
  moreTypes: true,
});

export function encodeConnect(msg: ConnectMessage): ArrayBuffer {
  return encodeMessage(MessageType.Connect, msg);
}

export function encodeInput(msg: InputMessage): ArrayBuffer {
  return encodeMessage(MessageType.Input, msg);
}

export function encodeUpgrade(upgrade: { tree: string; level: number }): ArrayBuffer {
  return encodeMessage(MessageType.Upgrade, upgrade);
}

export function encodeSnapshot(snapshot: SnapshotMessage): ArrayBuffer {
  const compressed = compressSnapshot(snapshot);
  return encodeMessage(MessageType.Snapshot, compressed);
}

export function encodePing(): ArrayBuffer {
  return encodeMessage(MessageType.Ping, { t: Date.now() });
}

export function encodePong(): ArrayBuffer {
  return encodeMessage(MessageType.Pong, { t: Date.now() });
}

export function encodeMatchEnd(data: { winnerId: string; placements: { id: string; p: number }[] }): ArrayBuffer {
  return encodeMessage(MessageType.MatchEnd, data);
}

export function encodeMessage(type: MessageType, payload: unknown): ArrayBuffer {
  const encoded = packr.encode(payload) as Buffer;
  const header = createHeader(type, encoded.byteLength);
  const result = new ArrayBuffer(HEADER_SIZE + encoded.byteLength);
  const resultView = new Uint8Array(result);
  resultView.set(new Uint8Array(header), 0);
  resultView.set(new Uint8Array(encoded.buffer, encoded.byteOffset, encoded.byteLength), HEADER_SIZE);
  return result;
}
